import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TDeleteFinixCardRequestSchema,
  TDeleteFinixCardResponseSchema,
} from "./deleteFinixCard.schema";

export const deleteFinixCard = (axios: IAxiosInstance) => {
  return async (body: TDeleteFinixCardRequestSchema) => {
    const response = await axios.noRetry.delete<
      IApiResponse<TDeleteFinixCardResponseSchema>
    >(`/api/business-cards/card`, { data: body });

    return response.data;
  };
};
